import { useEffect, useState, useRef } from "react";
import { toast } from "sonner";
import { api, errText } from "../../../lib/api";
import { UploadSimple } from "@phosphor-icons/react";

export const UploadDocForm = ({ categories, onUploaded }) => {
  const [deps, setDeps] = useState([]);
  const [category, setCategory] = useState(categories[0]);
  const [department, setDepartment] = useState("");
  const [title, setTitle] = useState("");
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef();

  useEffect(() => { api.get("/departments").then((r) => setDeps(r.data)); }, []);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    fd.append("category", category);
    fd.append("department", department);
    fd.append("title", title);
    try {
      await api.post("/company-documents", fd);
      toast.success("Document published — employees can now view it");
      setTitle("");
      onUploaded();
    } catch (err) { toast.error(errText(err)); } finally { setUploading(false); e.target.value = ""; }
  };

  return (
    <div className="bg-white border border-stone-200 rounded-lg p-6 space-y-4">
      <h3 className="font-heading font-bold">Publish a document</h3>
      <div className="flex flex-wrap items-end gap-3">
        <div>
          <label className="text-xs font-semibold text-stone-500">Category</label>
          <select value={category} onChange={(e) => setCategory(e.target.value)} data-testid="company-doc-category-select"
            className="mt-1 block min-h-[44px] px-3 rounded-lg border border-stone-300 bg-white">
            {categories.map((c) => <option key={c}>{c}</option>)}
          </select>
        </div>
        <div>
          <label className="text-xs font-semibold text-stone-500">Department (optional)</label>
          <select value={department} onChange={(e) => setDepartment(e.target.value)} data-testid="company-doc-department-select"
            className="mt-1 block min-h-[44px] px-3 rounded-lg border border-stone-300 bg-white">
            <option value="">Company-wide</option>
            {deps.map((d) => <option key={d.id} value={d.name}>{d.name}</option>)}
          </select>
        </div>
        <div className="flex-1 min-w-[180px]">
          <label className="text-xs font-semibold text-stone-500">Title (optional)</label>
          <input placeholder="e.g. Production hierarchy 2026" value={title} onChange={(e) => setTitle(e.target.value)} data-testid="company-doc-title-input"
            className="mt-1 block w-full min-h-[44px] px-3 rounded-lg border border-stone-300" />
        </div>
        <input ref={fileRef} type="file" accept=".pdf,.jpg,.jpeg,.png,.webp,.doc,.docx,.xls,.xlsx" onChange={upload} className="hidden" data-testid="company-doc-file-input" />
        <button onClick={() => fileRef.current?.click()} disabled={uploading} data-testid="upload-company-doc-button"
          className="tap-scale flex items-center gap-2 px-6 py-3 rounded-full bg-primary text-white text-sm font-bold hover:bg-[#A63F07] transition-colors duration-200 disabled:opacity-60">
          <UploadSimple size={16} weight="bold" /> {uploading ? "Uploading…" : "Choose file & publish"}
        </button>
      </div>
      <p className="text-xs text-stone-400">PDF, images, Word or Excel · max 10 MB</p>
    </div>
  );
};
